import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledLink = styled.a`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #0095ff;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #0077cc !important;
    text-decoration: underline !important;
  }

  &:active {
    color: #0068b3 !important;
  }
`;

const Link = ({ children, to, ...rest }) => {
  return (
    <StyledLink href={to} {...rest}>
      {children}
    </StyledLink>
  );
};

Link.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  to: PropTypes.string,
};
export default Link;
